// FAQSidebar.js
import React from 'react';

const FAQSidebar = ({ faqData, activeCategory, setActiveCategory }) => {
  return (
    <div className="w-full md:w-1/4 md:pr-8 mb-8 md:mb-0">
      <div className="bg-white rounded-xl shadow-sm border border-gray-100 p-4 sticky top-24">
        <h2 className="text-xl font-semibold text-[#113262] mb-4">Categories</h2>
        <ul className="space-y-2">
          {Object.entries(faqData).map(([key, value]) => (
            <li key={key}>
              <button
                className={`w-full text-left px-3 py-2 rounded-lg transition-colors duration-150 ${
                  activeCategory === key
                    ? 'bg-[#E8EEF6] text-[#113262] font-medium'
                    : 'text-gray-600 hover:bg-gray-50'
                }`}
                onClick={() => setActiveCategory(key)}
              >
                {(key.charAt(0).toUpperCase() + key.slice(1)).replace(/[-_]/g, " ")}

              </button>
            </li>
          ))}
        </ul>
      </div>
    </div>
  );
};

export default FAQSidebar;